export default __webpack_public_path__ + "static/media/groupe332.8d1172c8.svg";